import { TFunction } from 'i18next';
import _ from 'lodash';

import { JetDecisionOutcomes } from '@breathelife/types';
import { StaticSubscriber } from '@zinnia/form-engine-sdk';

import { PlatformFeatures } from '../../../Models/PlatformFeatures';
import { notificationSlice } from '../../../ReduxStore/Notification/NotificationSlice';
import { Dispatch } from '../../../ReduxStore/types';
import ApiService from '../../../Services/ApiService';

const DEBOUNCE_DELAY = 2000;

export const createJetSubscriber = (
  applicationId: string,
  setIsFetching: (value: boolean) => void,
  setJetDecisionOutcomes: (jetDecisionOutcomes: JetDecisionOutcomes[]) => void,
  features: PlatformFeatures,
  dispatch: Dispatch,
  t: TFunction,
): StaticSubscriber => {
  const debouncedJetUpdate = _.debounce(async (questionnaireEngine) => {
    if (features.assistedApplication?.jetDecisionWidget?.enabled && !!applicationId) {
      setIsFetching(true);
      const answers = questionnaireEngine.getAnswerResolverInstance().dump();

      try {
        const jetDecisionOutcomes = await ApiService.getJetDecisionOutcomes(applicationId, answers.v1, answers.v2);
        setJetDecisionOutcomes(jetDecisionOutcomes);
      } catch (e: unknown) {
        setJetDecisionOutcomes([]);
        dispatch(
          notificationSlice.actions.setError({
            message: t('notifications.failedToLoadJetDecisionOutcomes'),
          }),
        );
      } finally {
        setIsFetching(false);
      }
    }
  }, DEBOUNCE_DELAY);
  return async (questionnaireEngine) => {
    void debouncedJetUpdate(questionnaireEngine);
  };
};
